<template>
  <div id="capabilitiesPage">
    <ul>
      <li>Product Marketing/Business Development</li>
      <li>Project Management</li>
      <li>System Engineering & System Integration</li>
      <li>Requirements & Interface Management</li>
      <li>Software Development</li>
      <li>Subsystem Engineering</li>
      <li>Rapid Prototyping</li>
      <li>Export Compliance (ITAR/EAR)</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CapabilitiesPage'
}
</script>

<style>
  ul {
    list-style: none;
    margin: 0;
    padding-left: 1em;
    text-indent: -1em;
  }
  ul > li:before {
    content: "-";
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/CapabilitiesPage.vue